import { GET_MY } from '../../containers/App/constants';
import { resizeAndRotate } from '../../utils/image';
import { fetchCompany } from '../Companies/actions';
import { fetchUser } from '../Users/actions';
import {
  REQUEST_ADD_DOCUMENT,
  REQUEST_ADD_MULTIPLE_DOCUMENTS,
  REQUEST_DELETE_DOCUMENT,
  REQUEST_COMPANY_DOCUMENTS,
  REQUEST_VEHICLE_DOCUMENTS,
  REQUEST_VEHICLE_INVOICE_DOCUMENT,
  REQUEST_UPDATE_DOCUMENT_LAYERS,
  REQUEST_UPDATE_IMAGE_LAYERS,
} from '../Users/constants';
import { fetchVehicle } from '../Vehicles/actions';

const _fetch = function(type, id) {
  switch (type) {
    case 'user':
      return fetchUser(id);
    case 'vehicle':
      return fetchVehicle(id);
    case 'company':
      return fetchCompany(id);
  }
  debugger;
};

export function fetchCompanyDocuments(companyId, callback) {
  return {
    type: GET_MY,
    work: REQUEST_COMPANY_DOCUMENTS,
    gate: REQUEST_COMPANY_DOCUMENTS,
    path: `document/entityType/company/entityId/${companyId}`,
    callback,
  };
}

export function fetchVehicleDocuments(vehicleId, callback) {
  return {
    type: GET_MY,
    work: `${REQUEST_VEHICLE_DOCUMENTS}-${vehicleId}`,
    gate: REQUEST_VEHICLE_DOCUMENTS,
    path: `document/entityType/vehicle/entityId/${vehicleId}`,
    callback,
  };
}

export function fetchVehiclePurchaseInvoiceDocument(documentId, callback) {
  return {
    type: GET_MY,
    work: REQUEST_VEHICLE_INVOICE_DOCUMENT,
    gate: REQUEST_VEHICLE_INVOICE_DOCUMENT,
    path: `document/${documentId}/data`,
    callback,
  };
}

export function addDocument(entityId, entityType, documentDto, callback, work) {
  documentDto.entities = JSON.stringify([{ entityId, entityType }]);
  if (documentDto.extra) documentDto.extra = JSON.stringify(documentDto.extra);

  work = work ? [work] : [];
  work.push(REQUEST_ADD_DOCUMENT);

  return {
    type: GET_MY,
    work,
    gate: REQUEST_ADD_DOCUMENT + entityId,
    post: documentDto,
    options: { formData: true },
    path: `/document`,
    putOnComplete: [
      {
        ..._fetch(entityType, entityId),
        work,
      },
    ],
    callback,
  };
}

export function addMultipleDocs(entityId, entityType, documentsDto, callback, work) {
  documentsDto.entities = JSON.stringify([{ entityId, entityType }]);
  documentsDto.docs = JSON.stringify(documentsDto.docs);
  const formData = new FormData();
  formData.append('docs', documentsDto.docs);
  formData.append('entities', JSON.stringify([{ entityId, entityType }]));

  for (let i = 0; i < documentsDto.files.length; i++) {
    formData.append('files', documentsDto.files[i]);
  }
  console.log(formData, 'formData');

  work = work ? [work] : [];
  work.push(REQUEST_ADD_MULTIPLE_DOCUMENTS);

  return {
    type: GET_MY,
    work,
    gate: REQUEST_ADD_MULTIPLE_DOCUMENTS + entityId,
    post: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    path: `/document/multiple`,
    putOnComplete: [
      {
        ..._fetch(entityType, entityId),
        work,
      },
    ],
    callback,
  };
}

export function addDocToMultiSelectedEntities(entities, documentDto, callback, work) {
  documentDto.entities = JSON.stringify(entities);

  work = work ? [work] : [];
  work.push(REQUEST_ADD_DOCUMENT);

  return {
    type: GET_MY,
    work,
    gate: REQUEST_ADD_DOCUMENT,
    post: documentDto,
    options: { formData: true },
    path: `/document`,

    callback,
  };
}

export function deleteDocument(entityId, entityType, documentId, callback) {
  return {
    type: GET_MY,
    work: REQUEST_DELETE_DOCUMENT,
    gate: REQUEST_DELETE_DOCUMENT + entityId,
    delete: {},
    path: `/document/${documentId}/${entityType}/${entityId}`,
    putOnComplete: [_fetch(entityType, entityId)],
    callback,
  };
}

export function updateDocumentLayers(documentId, layers, callback) {
  return {
    type: GET_MY,
    work: REQUEST_UPDATE_DOCUMENT_LAYERS,
    patch: {
      layers,
    },
    path: `/document/${documentId}/layers`,
    callback,
  };
}

export function updateImageLayers(url, layers, callback) {
  return {
    type: GET_MY,
    work: REQUEST_UPDATE_IMAGE_LAYERS,
    patch: {
      layers,
      url,
    },
    path: `/document/image/layers`,
    callback,
  };
}
